import "./jquery-global.js";
import $ from "jquery";
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

//Bootstrap JS
import * as bootstrap from 'bootstrap';
import hcOffCanvasNav from 'hc-offcanvas-nav';
import Swiper from 'swiper/swiper-bundle.min.js';
import jConfirm from 'jConfirm/jConfirm.min.js';
import flatpickr from "flatpickr";
import printThis from "print-this";
import GLightbox from 'glightbox';
import {setupRecaptcha} from "./recaptcha";
import {artWorkApprovalShowHide} from './artwork-approval';
import {initShortListOperation} from "./shortlist";
import {initSearchForm} from "./search-form";
import {initArtWorkUploader} from "./artwork-uploader";
import {initAddToCart, initQuantity} from "./add-to-cart";
import {initColorSelector} from "./colour-selector";
import {initCheckout} from "./checkout";
import {initiateVatToggle} from "./vat-toggle";
import {initLookupAddress} from "./lookup-address";
import {initLeadApproval} from "./lead-approval";
import {leadFormInit} from "./lead-form";

let lgMinWidth = window.matchMedia("(min-width: 992px)");
let featureBarSwiper;

setupRecaptcha();


$(document).ready(function () {
    artWorkApprovalShowHide();
    initShortListOperation();
    initSearchForm();
    initArtWorkUploader();
    initColorSelector();
    initAddToCart();
    initQuantity();
    initCheckout();
    initiateVatToggle();
    lgMinWidthHandler(lgMinWidth);
    initLookupAddress();
    initLeadApproval();
    leadFormInit();
    lgMinWidth.addListener(lgMinWidthHandler);

    GLightbox({
        selector: ".glightbox",
    });

    $("[data-print]").each(function () {
        let self = $(this);
        let container = self.data('print');
        self.on("click", function () {
            $(container).printThis();
        });
    });

    //mobile nav
    let Nav = new hcOffCanvasNav('#mobile-nav', {
        disableAt: 1024,
        customToggle: '.toggle',
        navTitle: 'All Categories',
        levelTitles: true,
        levelTitleAsBack: true
    });

    $('a[data-toggle="confirm"]').jConfirm().on('confirm', function (e) {
        let link = $(this);
        window.location = link.attr('href');
    });

    //initiate tooltip (otherwise wont work)
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    //swiper sliders
    let swiper = new Swiper(".four-col-swiper", {
        slidesPerView: 4,
        spaceBetween: 30,
        lazy: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            // mobile
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            // small
            767: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            // medium
            992: {
                slidesPerView: 3,
                spaceBetween: 0
            },
            //large
            1199: {
                slidesPerView: 4,
                spaceBetween: 20
            }
        }
    });

    let swiper1 = new Swiper(".product-swiper", {
        slidesPerView: 4,
        spaceBetween: 30,
        lazy: true,
        navigation: {
            nextEl: ".swiper-button-next-product",
            prevEl: ".swiper-button-prev-product",
        },
        breakpoints: {
            // mobile
            320: {
                slidesPerView: 1,
                spaceBetween: 20
            },
            // small
            767: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            // medium
            992: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            //large
            1199: {
                slidesPerView: 4,
                spaceBetween: 20
            }
        }
    });

    let swiper2 = new Swiper(".product-swiper-thumb", {
        spaceBetween: 30,
        slidesPerView: 3,
        lazy: true,
        watchSlidesProgress: true,
    });

    let productSliderOptions = {
        spaceBetween: 10,
        lazy: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    };

    let quoteSlider = new Swiper(".quote-swiper", {
        navigation: {
            nextEl: ".swiper-button-next-quote",
            prevEl: ".swiper-button-prev-quote",
        }
    });

    //check if thumbnails are present
    if ($('.product-swiper-thumb .swiper-slide').length > 0) {
        productSliderOptions.thumbs = {
            swiper: swiper2,
        };
    }

    let swiper3 = new Swiper(".product-page-swiper", productSliderOptions);

    let mobileSearchCollapse = $('#mobileSearchCollapse');
    let collapseBackground = mobileSearchCollapse.find('.dropdown-background');
    mobileSearchCollapse.on('hide.bs.collapse', function () {
        $('body').removeClass("h-100 overflow-hidden");
    });
    mobileSearchCollapse.on('show.bs.collapse', function () {
        $('body').addClass("h-100 overflow-hidden");
        collapseBackground.css('top', $('header').height());
    });

    collapseBackground.on("click", function (e) {
        if (e.target === this) {
            mobileSearchCollapse.collapse('hide');
        }
    });

    $('input[type="date"], input.flatpickr-input').each(function () {
        let self = $(this);

        let maxDate = undefined;
        if (self.data("max-date")) {
            let maxDateString = self.data("max-date");
            if (maxDateString === "today") {
                maxDate = new Date();
            } else if (maxDateString) {
                maxDate = new Date(maxDateString);
            }
        }

        let minDate = undefined;
        if (self.data("min-date")) {
            let minDateString = self.data("min-date");
            if (minDateString === "today") {
                minDate = new Date();
            } else if (minDateString) {
                minDate = new Date(minDateString);
            }
        }

        let defaultValue = self.attr('value');
        if (defaultValue) {
            defaultValue = new Date(defaultValue);
        }

        let options = {
            // altFormat: "j F, Y",
            dateFormat: "d/m/Y",
            defaultDate: defaultValue,
            maxDate: maxDate,
            minDate: minDate,
            onChange: function (selectedDates, dateStr, instance) {
                self.val(dateStr);
            },
            onReady: function (dateObj, dateStr, instance) {
                $('.flatpickr-calendar').each(function () {
                    let $this = $(this);
                    if ($this.find('.flatpickr-clear').length < 1) {
                        $this.append('<div class="flatpickr-clear btn btn-sm btn-primary my-2">Clear</div>');
                        $this.find('.flatpickr-clear').on('click', function () {
                            instance.clear();
                            instance.close();
                        });
                    }
                });
            }
        };

        self.flatpickr(options);

    });
});

function destroyFeatureBarSwiper() {
    let carouselWrapper = $('.feature-bar .carousel-wrapper');
    //Destroy swiper on xl devices
    if (featureBarSwiper) {
        featureBarSwiper.destroy(true, false);
        carouselWrapper.find('.swiper-slide').removeAttr('style');
        carouselWrapper.find('.swiper-slide').removeAttr('aria-label');
        carouselWrapper.find('.swiper-slide').removeAttr('role');
        carouselWrapper.find('.swiper-slide').attr("class", "d-flex align-items-center col-auto");
        carouselWrapper.html(carouselWrapper.children('.swiper-wrapper').html());
        carouselWrapper.attr("class", 'row w-100 gx-4 list-unstyled my-0 justify-content-center carousel-wrapper');
    }
}

function initFeatureBarSwiper() {
    let carouselWrapper = $('.feature-bar .carousel-wrapper');
    //Initiate swiper on smaller devices than xl
    carouselWrapper.attr("class", 'swiper carousel-wrapper my-0 w-100');
    carouselWrapper.children('.col-auto').attr("class", "swiper-slide bg-transparent d-flex align-items-center");
    carouselWrapper.html(`<div class="swiper-wrapper w-100">${carouselWrapper.html()}</div>`);

    featureBarSwiper = new Swiper(".feature-bar .swiper", {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        rewind: true,
        watchSlidesProgress: true,
        slideVisibleClass: "swiper-visible-slide",
        breakpoints: {
            // mobile
            0: {
                slidesPerView: 1
            },
            // small
            576: {
                slidesPerView: 2
            }
        }
    });
}

function lgMinWidthHandler(e) {
    if (e.matches) {
        destroyFeatureBarSwiper();
    } else {
        initFeatureBarSwiper();
    }
}
